import { useTranslation } from 'next-i18next'

import { css } from '@emotion/react'

import { Parking } from '@/service'

import { H3Styles, LegiaBlack, Text2Styles } from '@/styles/typography'
import { colors } from '@/styles/theme'
import { focusVisible, underlineHover } from '@/styles/mixins'
import { mediaUp } from '@/styles/media'

interface Props {
  parking: Parking
  commonLink?: boolean
}

function PricingModalButton(props: Props) {
  const { t } = useTranslation('parkings')
  const { parking, commonLink } = props

  const handleOpenModal = () => {
    const event = new CustomEvent('openPricingModal', {
      detail: { slug: parking.urlSlug }
    })
    window.dispatchEvent(event)
  }

  return (
    <>
      {(parking.subscriptionAvailable || parking.reservationAvailable) && (
        <div
          css={[
            styles.pricingButtonWrapper,
            commonLink && styles.pricingButtonWrapperLeft
          ]}
        >
          <button
            css={[styles.link, commonLink && styles.linkCommon]}
            onClick={handleOpenModal}
            type="button"
          >
            {t('seePriceList')}
          </button>
        </div>
      )}
    </>
  )
}

const styles = {
  pricingButtonWrapper: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  pricingButtonWrapperLeft: css`
    justify-content: start;
    align-items: start;
  `,
  link: css`
    ${focusVisible};
    ${H3Styles};
    ${underlineHover};
    color: ${colors.darkSkyBlue};
    margin: 4px 0 10px;
    background: none;
    border: none;
    cursor: pointer;
    text-decoration: underline;
    padding: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    display: inline;

    ${mediaUp('lg')} {
      margin: 12px 0 20px;
    }

    .legia-warszawa & {
      ${LegiaBlack};
      color: var(--accentFirstCustom);
    }
  `,
  linkCommon: css`
    ${Text2Styles};
    color: ${colors.twilightBlue};
    margin: 0;
  `
}

export default PricingModalButton
